const MOCK_COMMENTS = {
    'comments': [
        {
            'key': 0,
            'username': 'faretheewell.magpie',
            'text': 'Wow! Cool hat!',
            'timestamp': 1594502184665,
            'likes': 1,
            'likedByUser': false,
            'replies': [],
        },
        {
            'key': 1,
            'username': 'mindybyrdlegs',
            'text': 'I, personally, love the Ross School of Business and I\'m glad you could visit 🐍🐍🐍🐍',
            'timestamp': 1594502184665,
            'likes': 4,
            'likedByUser': false,
            'replies': [],
        },
        {
            'key': 2,
            'username': 'mkguth',
            'text': 'You claim you took this last week, yet the leaves are clearly a fall shade, how curious 🤔🤔',
            'timestamp': 1594502184665,
            'likes': 10,
            'likedByUser': false,
            'replies': [],     
        },
        {
            'key': 3,
            'username': 'brittravelin',
            'text': 'OMG! That hat with the boat on it is fire',
            'timestamp': 1594601184665,
            'likes': 1,
            'likedByUser': false,
            'replies': [],   
        },
    ]
}

export default MOCK_COMMENTS;